// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news_1Ox5v","mobile":"News_mobile_371gB","news__heading":"News_news__heading_2-DKa","news-list":"News_news-list_3S6vR","news-list__item":"News_news-list__item_jj_fJ"};